<template>
  <common-page-edit
    :title="title"
    :nameRoleEntity="nameRoleEntity"
    :apiNameGet="apiNameGet"
    :apiNameCreate="apiNameCreate"
    :apiNameUpdate="apiNameUpdate"
    :routeNameShow="routeNameShow"
    :routeNameCreate="routeNameCreate"
    :keyRoute="'ContactId'"
    :backUrl="pathBack"
    @set-loadData="setLoadData"
    :convertLoadData="convertLoadData"
    :paramsSave="paramsSave"
    :isDefaultConverter="false"
    :paramsSend="paramsSend"
  >
  </common-page-edit>
</template>
<script>
import { API_METHODS } from "../../../../constant";
import { NAME_OBJECT } from "../../../../RoleConstanans";
import CommonPageEdit from "../../commonElement/CommonPageEdit.vue";
import CompanyData from "../company/CompanyData.vue";

import convertFieldInfoListToScheme from "../../../../helpers/converters/convetFieldInfoListToScheme";

export default {
  name: "EditPageContactMain",
  components: {
    CommonPageEdit,
    CompanyData
  },
  data() {
    return {
      wait: false,
      scheme: {},
      loadData: null,
      fieldInfoList: null,
      preResult: null,
      load: true,

      routeNameShow: "ClientShow",
      routeNameCreate: "ClientCreate",

      apiNameGet: API_METHODS.GET_CONTACT,
      apiNameCreate: API_METHODS.CREATE_CONTACT,
      apiNameUpdate: API_METHODS.UPDATE_CONTACT,
      loadData: null
    };
  },
  created() {
    this.routeNameShow = this.meta.routeNameShow;
    this.routeNameCreate = this.meta.routeNameCreate;
  },
  computed: {
    title() {
      let text1 = this.$t("Просмотр контакта");
      let text2 = this.$t("Создание контакта");
      let text3 = this.$t("Редактирование контакта");

      let findShow = this.$route.path.indexOf("show");
      if (findShow != -1) {
        return text1;
      }
      let findCreate = this.$route.path.indexOf("create");
      if (findCreate != -1) {
        return text2;
      }
      let findEdit = this.$route.path.indexOf("edit");
      if (findEdit != -1) {
        return text3;
      }
      return text1;
    },
    nameRoleEntity() {
      const nameRoute = this.$route.name;
      let role = this.meta.configName;
      switch (nameRoute) {
        case "AgentCreatePageContact":
        case "AgentShowPageContact":
        case "AgentEditPageContactMain": {
          role = NAME_OBJECT.ContactAgency;
          break;
        }
        case "ClientCreatePageContact":
        case "ClientShowPageContact":
        case "ClientEditPageContactMain": {
          role = NAME_OBJECT.ContactClient;
          break;
        }
      }

      return role;
    },
    paramsSend() {
      return {
        id: this.$route.params.ContactId || "0",

        SubjectId: this.$route.params[this.meta.fieldRoute]
      };
    },
    meta() {
      return this.$route.meta;
    },
    pathBack() {
      return `/company/${this.meta.typeCompany}/${this.$route.params.CompanyId}/edit`;
    }
  },

  methods: {
    convertLoadData(res) {
      let loadData = res.object;
      let fieldInfoList = res.fieldInfoList;
      let scheme = { configForm: [] };

      scheme.configForm = convertFieldInfoListToScheme({
        fieldInfoList,
        hasLang: false
      });

      loadData.subjectId = this.$route.params[this.meta.fieldRoute];

      return {
        loadData,
        fieldInfoList,
        scheme
      };
    },
    setLoadData(loadData) {
      this.loadData = loadData;
    },

    paramsSave() {
      return {
        id: this.$route.params.ContactId,
        SubjectId: this.$route.params[this.meta.fieldRoute]
      };
    }
  }
};
</script>
